<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i> Saha Giderleri</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">anasayfa</a></li>
        </ul>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-lg-6">
            <div class="col-lg-12" style="background-color:#c1163b">
              <div
                style="font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">Saha =>{{ result.sahaName }}</p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">
                  Makina =>{{ personelData.makina_code }}
                  {{ personelData.makina_name }}
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">Opr =>{{ personelData.opr_one }}</p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">Yrd =>{{ personelData.yrd_one }}</p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:#c1163b">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">
                  Tamamlanan iş Yüzdesi => %{{ result.isyuzdesi }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">
                  TOPLAM GİDER => {{ detailData.gider }}₺
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">
                  TOPLAM YAKIT(L) => {{ detailData.yakit }}L
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">
                  DELİK BAŞI YAKIT(L) => {{ detailData.delikyakit }}L
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">
                  DELİK BAŞI GENEL MALİYET => {{ detailData.maliyet }}₺
                </p>
              </div>
            </div>
            <div class="col-lg-12" style="background-color:rgb(239, 24, 24)">
              <div
                style=" font-size: 23px;font-weight: bolder;margin-bottom: 10px;"
              >
                <p style="color: white;">
                  DELİK BAŞI KAR KDV DAHİL=> {{ detailData.kar }}₺
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button @click="pdfdownload()" class="btn btn-info" type="button">
          PDF İNDİR
        </button>
        <button @click="gomakinefilter()" class="btn btn-secondary" type="button">
          MAKİNE FİLTRELE
        </button>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <div class="tile-body">
              <table class="table table-hover table-bordered" id="sampleTable">
                <thead>
                  <tr>
                    <th>id</th>
                    <th>Personel Adı</th>
                    <th>Makina Bilgileri</th>
                    <th>Kategori</th>
                    <th>Ödeme Tutarı</th>
                    <th>Kullanıcı</th>
                    <th>Açıklama</th>
                    <th>Detay</th>
                    <th>Kayıt Tarhi</th>
                    <th>Oluşturma Tarihi</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      result: [],
      personelData: [],
      detailData: [],
      isyuzdesi: "",
      noteId: "",
      saha_idm: this.$route.query.id,
      saha_id2: this.$route.query.id,
    };
  },
  mounted: function() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    var admin_token = localStorage.getItem("admin_token");
    if (!token && !admin_token) {
      this.$router.push("/");
    }
    var datas = {
      saha_id: this.saha_idm.substr(0,3),
      token: token,
      id: id,
    };

    let dataUrl =
      store.state.base_url + "AslanSahalar/getBySahaDetail.php?key=123";
    axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.result = response.data.data[0];
      this.personelData = response.data.temp;
      this.detailData = response.data.data[0].detail;
    });
    var results = this.result;
    let url = store.state.base_url + "AslanSahalar/getAllGider.php?key=123";
    var datas2 = {
      sahaId: this.saha_idm.substr(0,3),
      token: token,
      id: id,
    };
    axios
      .post(url, JSON.stringify(datas2))
      .then((response) => {
        datas2 = response.data;
        var table = $("#sampleTable").DataTable(
        {
                        pageLength: 20,
                        order: [[0, 'desc']]
                    });
        $.each(datas2, function(index, value) {
          table.row
            .add([
              value["id"],
              value["personel_id"],
              value["makina_id"],
              value["categoryId"],
              value["tutar"] + "₺",
              value["userId"],
              value["aciklamaone"],
              value["aciklamatwo"],
              value["date"],
              value["reg_date"],
            ])
            .draw(false);
        });

        $("#sampleTable tbody").on("click", "tr", function() {
          var data = table.row(this).data();
          results.id = data[0];
          window.location.href = "#/updategider?id=" + results.id;
        });
      })
      .catch((err) => {
        //console.log(err.response);
      });
  },
  methods: {
    gomakinefilter: function() {
      window.location.href = "#/giderfiltrele?idm=" + this.saha_idm;
    },
    pdfdownload() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/index2.php?key=123&keyword=${this.saha_idm}`, "_blank");
    },

  },
  components: {
    Header,
    Sidebar,
  },
};
</script>

<style>
#spanRegdate {
  font-size: 20px;
  text-align: right;
  display: block;
  margin-right: 10px;
  color: #c1163b;
}
#spanContent {
  font-size: 25px;
  margin-right: 10px;
  color: #c66a7e;
}
#pid1 {
  border-radius: 3px 22px;
  background-color: #5fe0d7;
  text-align: center;
  font-size: 25px;
}
#pid2 {
  border-radius: 3px 22px;
  background-color: #5fe0d7;
  text-align: center;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/StudentsDetail.vue